export default "__VITE_ASSET__BSSFcErD__"